import * as React from 'react';
import classnames from 'classnames';
import { st, classes } from './Button.st.css';
import { CoreButtonNext as ButtonNext } from '../internal/WixUiCoreComponents/components/CoreButtonNext';
import { useTPAComponentsContext } from '../TPAComponentsConfig';
import { deprecationLog } from '../../common/deprecationLog';
import { AffixTypes, HoverStyles, PaddingModes, ButtonSize, } from './types';
import { fontConfigMap } from './constants';
const wrapAffix = (icon, type) => (React.createElement("span", { className: classnames(classes[`${type}-icon`], classes.affixIcon) }, icon));
const getFontConfig = (size = ButtonSize.medium, paddingMode, mobile) => {
    const deviceType = mobile ? 'mobile' : 'desktop';
    return fontConfigMap[paddingMode][size][deviceType];
};
const ButtonComponent = ({ priority, size, fullWidth = false, innerRef, upgrade = false, wrapContent = false, paddingMode = upgrade ? PaddingModes.dynamicPaddings : PaddingModes.legacy, children, className, prefixIcon, suffixIcon, 'data-hook': dataHook, hoverStyle = HoverStyles.underline, style, contentClassName = '', ...rest }) => {
    const { mobile } = useTPAComponentsContext();
    const affixes = prefixIcon || suffixIcon
        ? {
            prefixIcon: prefixIcon
                ? wrapAffix(prefixIcon, AffixTypes.prefix)
                : undefined,
            suffixIcon: suffixIcon
                ? wrapAffix(suffixIcon, AffixTypes.suffix)
                : undefined,
        }
        : null;
    React.useEffect(() => {
        if (!upgrade) {
            deprecationLog('Button', 'The current `Button` component API will be deprecated in a future version. Please use the `upgrade` prop in order to use the new API.');
        }
    }, []);
    const fontConfig = getFontConfig(size, paddingMode, mobile);
    const dynamicStyle = {
        '--wix-ui-tpa-button-font-size-default': fontConfig.size,
        '--wix-ui-tpa-button-line-height-default': fontConfig.lineHeight,
        ...style,
    };
    return (React.createElement(ButtonNext, { "data-fullwidth": fullWidth, "data-mobile": mobile, ref: innerRef, children: children, "data-hook": dataHook, style: dynamicStyle, className: st(classes.root, {
            priority,
            size,
            fullWidth,
            mobile,
            paddingMode,
            wrapContent,
            hoverStyle,
        }, classnames(className, { [classes.hasIcon]: !!affixes })), contentClassName: classnames(contentClassName, classes.content), ...rest, ...affixes }));
};
export const Button = React.forwardRef((props, ref) => (React.createElement(ButtonComponent, { ...props, innerRef: ref })));
//# sourceMappingURL=Button.js.map